import { render } from "./PlaceholderImage.vue?vue&type=template&id=52d79d00&scoped=true&ts=true"
import script from "./PlaceholderImage.vue?vue&type=script&lang=ts"
export * from "./PlaceholderImage.vue?vue&type=script&lang=ts"

import "./PlaceholderImage.vue?vue&type=style&index=0&id=52d79d00&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src3320913318/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-52d79d00"]])

export default __exports__